import { render, staticRenderFns } from "./TrajectoryCards.vue?vue&type=template&id=27d30ed7&scoped=true"
import script from "./TrajectoryCards.vue?vue&type=script&lang=js"
export * from "./TrajectoryCards.vue?vue&type=script&lang=js"
import style0 from "./TrajectoryCards.vue?vue&type=style&index=0&id=27d30ed7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d30ed7",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationProgramsListTrajectoriesTrajectoryCard: require('/builds/gb-developers/geekbrains-client/components/pages/education/ProgramsList/Trajectories/TrajectoryCard/TrajectoryCard.vue').default})
